import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Account } from '../types/Account'
import { createAccount } from '../service/accountService'
import { useContextParameters } from '../../../services/api/hooks/useContextParameters'
import accountQueryKeys from './accountQueryKeys'

export const useCreateAccount = () => {
  const { companyId } = useContextParameters()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (account: Account) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }
      return createAccount(account, companyId)
    },
    onSuccess: createdItem => {
      queryClient.setQueryData<Account[]>(accountQueryKeys.list({ companyId }), old => {
        const list = Array.isArray(old) ? old : []
        return list.some(i => i.code === createdItem.code)
          ? list.map(i => (i.code === createdItem.code ? createdItem : i))
          : [...list, createdItem]
      })
    },
    onError: error => {
      console.error('Failed to create account:', error)
    }
  })
}
